import React from "react";
import { Nav } from "react-bootstrap";

/**
 * Song History lifecycle tabs — reflect Song Library Track state.
 * Active | Archived | Deleted. Not Song Processing tabs.
 */
export type SongHistoryLifecycleView = "active" | "archived" | "deleted";

export const SONG_HISTORY_LIFECYCLE_VIEWS = [
  "active",
  "archived",
  "deleted",
] as const satisfies readonly SongHistoryLifecycleView[];

export const SONG_HISTORY_LIFECYCLE_TAB_LABELS = {
  active: "Active",
  archived: "Archived",
  deleted: "Deleted",
} as const;

export function parseSongHistoryLifecycleView(
  raw: string | null | undefined,
): SongHistoryLifecycleView {
  if (raw === "archived" || raw === "deleted") return raw;
  return "active";
}

type Props = {
  view: SongHistoryLifecycleView;
  onSelect: (next: SongHistoryLifecycleView) => void;
  activeCountLabel?: string;
  archivedCountLabel?: string;
  deletedCountLabel?: string;
};

const SongHistoryLifecycleTabs: React.FC<Props> = ({
  view,
  onSelect,
  activeCountLabel = "",
  archivedCountLabel = "",
  deletedCountLabel = "",
}) => (
  <Nav
    variant="tabs"
    activeKey={view}
    onSelect={(key) =>
      onSelect(parseSongHistoryLifecycleView(key || "active"))
    }
    className="mb-3"
    data-testid="song-history-lifecycle-tabs"
  >
    <Nav.Item>
      <Nav.Link eventKey="active">
        {SONG_HISTORY_LIFECYCLE_TAB_LABELS.active}
        {activeCountLabel}
      </Nav.Link>
    </Nav.Item>
    <Nav.Item>
      <Nav.Link eventKey="archived">
        {SONG_HISTORY_LIFECYCLE_TAB_LABELS.archived}
        {archivedCountLabel}
      </Nav.Link>
    </Nav.Item>
    <Nav.Item>
      <Nav.Link eventKey="deleted">
        {SONG_HISTORY_LIFECYCLE_TAB_LABELS.deleted}
        {deletedCountLabel}
      </Nav.Link>
    </Nav.Item>
  </Nav>
);

export default SongHistoryLifecycleTabs;
